import { Directive, effect, EffectRef, ElementRef, inject, input, InputSignal, Renderer2 } from '@angular/core';
import { IGridStyle } from './interfaces';

@Directive({
	selector: '[adaViewboxGridDirective]',
})
export class ViewboxGridDirective {

	public readonly x: InputSignal<number> = input(0);

	public readonly y: InputSignal<number> = input(0);

	public readonly z: InputSignal<number> = input(1.0);

	public readonly renderGrid: InputSignal<boolean> = input(true, { alias: 'adaViewboxGridDirective' });

	public readonly gridStyles: InputSignal<IGridStyle[]> = input();

	protected readonly elementRef: ElementRef<HTMLElement> = inject(ElementRef);

	private readonly _renderer: Renderer2 = inject(Renderer2);

	protected readonly canvasFx: EffectRef = effect(() => {
		if (this.renderGrid()) {
			const _host: HTMLElement = this.elementRef.nativeElement;

			this.gridStyles().forEach((_gridProperty: IGridStyle) => {
				this._renderer.setStyle(_host, _gridProperty.style, _gridProperty.value);
			});

			this._renderer.setStyle(_host, 'background-size', `${100 * this.z()}px ${100 * this.z()}px`);
			this._renderer.setStyle(_host, 'background-position', `${this.x()}px ${this.y()}px`);
		}
	});

}

